import type { FaireProductEntity } from "../../entity_types/product";

export const p_uy9k6hznph: FaireProductEntity = {
  token: "p_uy9k6hznph",
  type: "product",
  name: "Freshly Picked Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/69b11ce1c747efb257ffd6215d9b74a001fbf3922857e9c7326cc500ec5eeec6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8d981c898d27a5b89b1909751a3b422d0f8a983d0be82defcba40faa11bcb329.jpeg",
    "https://cdn.faire.com/fastly/3c3da5a0afe063903f5cd863f2da8154088d5d6d4270a2178b71855a2a85efb1.jpeg",
    "https://cdn.faire.com/fastly/e7e48794ce4c9136065d87fefd0f6aeefa84d9133bdc2b9dd6ec14844660607e.jpeg",
    "https://cdn.faire.com/fastly/7dd1cb23ee124a4b2d137b0344345740e7277012a1d3b773f97a35b4f239e685.png",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:45.839Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
